import initialState from '../initialstate';
import {reviewNoteStatusFilter} from '../..//util/uiconstants';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function ReviewNoteDocumentReducer(state = initialState.reviewNoteDocument, action) {
	switch (action.type) {
		case types.SET_REVIEWNOTE_DOCUMENT: {
			return _.cloneDeep(action.documents);
		}
		case types.CLEAN_REVIEWNOTE_DOCUMENT: {
			return null;
		}
		case types.POST_RNH_NEW_NOTE: {
			if (state && Array.isArray(state)) {
				let _state = _.cloneDeep(state);
				let doc = _state.find((x) => x.value?.toLowerCase() === action.noteInfo?.entityUID?.toLowerCase());

				if (doc) {
					doc.engagementReviewNoteCount++;
				}

				return _state;
			} else {
				return state;
			}
		}
		case types.UPDATE_RNH_NOTES_COUNT: {
			if (state && Array.isArray(state)) {
				let _state = _.cloneDeep(state);
				let doc = _state.find((x) => x.value?.toLowerCase() === action.entityId?.toLowerCase());

				if (doc) {
					let count = doc.engagementReviewNoteCount;
					if (action.statusId === reviewNoteStatusFilter.Open) {
						// status changed to reopen
						count++;
					} else {
						if (action.oldStatusId === reviewNoteStatusFilter.Open) {
							// open status changed
							count--;
						}
					}

					doc.engagementReviewNoteCount = count;
				}

				return _state;
			} else {
				return state;
			}
		}
		default:
			return state;
	}
}
